import type { TradeLogicRegistryActionTemplateDto, TradeLogicRegistryConditionTemplateDto } from '../registry';

export const matchesTradeLogicDocumentKind = (documentKinds: string[], kind: 'entry' | 'exit') =>
    documentKinds.length === 0 || documentKinds.includes(kind);

const inferConditionTemplateKind = (template: TradeLogicRegistryConditionTemplateDto): 'entry' | 'exit' | null => {
    if (template.documentKinds.includes('entry') && !template.documentKinds.includes('exit')) return 'entry';
    if (template.documentKinds.includes('exit') && !template.documentKinds.includes('entry')) return 'exit';

    const metadataCategory = typeof template.metadata?.category === 'string' ? template.metadata.category : null;

    if (metadataCategory === 'entryCondition') return 'entry';
    if (metadataCategory === 'exitCondition') return 'exit';

    const tagSet = new Set(
        Array.isArray(template.ui?.tags) ? template.ui.tags.filter((tag): tag is string => typeof tag === 'string') : []
    );

    if (tagSet.has('entry') && !tagSet.has('exit')) return 'entry';
    if (tagSet.has('exit') && !tagSet.has('entry')) return 'exit';

    if (template.templateKey.startsWith('entry.')) return 'entry';
    if (template.templateKey.startsWith('exit.')) return 'exit';

    return null;
};

export const filterTradeLogicActionTemplatesForKind = (templates: TradeLogicRegistryActionTemplateDto[], kind: 'entry' | 'exit') =>
    templates.filter((template) => matchesTradeLogicDocumentKind(template.documentKinds, kind));

export const filterTradeLogicConditionTemplatesForKind = (templates: TradeLogicRegistryConditionTemplateDto[], kind: 'entry' | 'exit') =>
    templates.filter((template) => {
        if (template.documentKinds.length > 0) {
            return matchesTradeLogicDocumentKind(template.documentKinds, kind);
        }

        const inferredKind = inferConditionTemplateKind(template);
        return inferredKind === null || inferredKind === kind;
    });
